let timer;
export default {
  tryLogin(context) {
    const token = localStorage.getItem('token');
    const userId = localStorage.getItem('userId');
    const tokenExpiration = localStorage.getItem('tokenExpiration');

    const expiresIn = +tokenExpiration - new Date().getTime;

    if (expiresIn < 0) {
      return;
    }

    timer = setTimeout(function () {
      context.dispatch('logout');
      context.dispatch('didAutoLogout');
    }, expiresIn);

    if (token && userId) {
      context.commit('setUser', {
        token: token,
        userId: userId,
      });
    }
  },
  async auth(context, payload) {
    const mode = payload.mode;
    let url =
      'https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyDncIYGg9bfmqZYJ2HiFmx9z-wNT-_rJhE';

    if (mode === 'signup')
      url =
        'https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyDncIYGg9bfmqZYJ2HiFmx9z-wNT-_rJhE';

    const response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        email: payload.email,
        password: payload.password,
        returnSecureToken: true,
      }),
    });
    const responseData = await response.json();

    if (!response.ok) {
      const error = new Error(
        responseData.message || 'Faild to Authenticate , Check Your Data'
      );
      throw error;
    }

    const expiresIn = +responseData.expiresIn * 1000;

    const tokenExpiration = new Date().getTime + expiresIn;

    localStorage.setItem('token', responseData.idToken);
    localStorage.setItem('userId', responseData.localId);
    localStorage.setItem('tokenExpiration', tokenExpiration);

    timer = setTimeout(function () {
      context.dispatch('logout');
      context.dispatch('didAutoLogout');
    }, expiresIn);

    context.commit('setUser', {
      token: responseData.idToken,
      userId: responseData.localId,
    });
  },

  async signup(context, payload) {
    return context.dispatch('auth', { ...payload, mode: 'signup' });
  },
  async login(context, payload) {
    return context.dispatch('auth', { ...payload, mode: 'login' });
  },

  logout(context) {
    context.commit('setUser', {
      token: null,
      userId: null,
    });
    clearTimeout(timer);
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('tokenExpiration');
  },
  didAutoLogout(context) {
    context.dispatch('logout');
    context.commit('didAutoLogout');
  },
};
